import axios from 'axios'
const urlbase =
  process.env.VUE_APP_API_SERVER_QEC ?? 'https://testapidev.co/api/v1/qec/'

export const qecAxios = axios.create({
  baseURL: urlbase,
  headers: {
    'content-type': 'application/json',
    accept: 'application/json',
  },
})

export default qecAxios
